import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { MDI_SUB } from "@/shared/constants/GeneralConstants";

@Component({
  name: "ShowIcon",
  components: {}
})
export default class ShowIcon extends Vue {
  @Prop() icon!: string;
  mdiIcon = true;
  mounted() {
    this.evaluateIcon();
  }

  @Watch("icon")
  evaluateIcon() {
    this.mdiIcon = this.icon.includes(MDI_SUB);
  }
}
